var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "checklist"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26736_323",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26736_323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checklist_2",
    d: "M7.4013 25.3334L2.66797 20.6001L4.53464 18.7334L7.36797 21.5667L13.0346 15.9001L14.9013 17.8001L7.4013 25.3334ZM7.4013 14.6667L2.66797 9.9334L4.53464 8.06673L7.36797 10.9001L13.0346 5.2334L14.9013 7.1334L7.4013 14.6667ZM17.3346 22.6667V20.0001H29.3346V22.6667H17.3346ZM17.3346 12.0001V9.3334H29.3346V12.0001H17.3346Z",
    fill: "#7400CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistAlt);
export default __webpack_public_path__ + "static/media/checklist-alt.12b661ece04be2c744c47a8881584c57.svg";
export { ForwardRef as ReactComponent };